import {
    Container,
    Grid,
    MenuItem,
    Paper,
    Typography
} from '@material-ui/core';
import { VoucherModeBalanceAdd as INSERT } from 'Components/Api/VoucherAPI';
import { SelectByReceiverID as SELECT_PAYMENT_MODE_BYID } from 'Components/Api/PaymentModesAPI';
import { SelectByParentID as SELECT_BY_PARENT_ID } from 'Components/Api/UserBankDetailApi';
import { SelectDownlinForFundTransfer as USER_SELECT_DOWNLINE_FOR_FUND_TRANSFER } from 'Components/Api/UsersApi';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import InputLabel from 'Components/Inputes/InputLabel';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import HOCLoader from 'Components/Loader/HOCLoader';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import { LOGOUT } from 'ConstComponents';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { PLEASE_SELECT_VALID } from 'Components/Helper/Messages';
import { SHOW_PAYMODE } from 'Config';
import { FETCH_LIST } from 'Config';
import Divider from '@material-ui/core/Divider';
import {
    PrimaryButton,
    SecondaryButton,
    InfoButton
} from 'Components/Inputes/CustomButton';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import { RECEIPT_VOUCHER_ID } from 'Components/Helper/Messages';
const CustomContainer = HOCLoader(Container);

export const VoucherModeBalanceAdd = () => {
    const history = useHistory();
    const formRef = useRef();
    const [responseMessage, setResponseMessage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [downline, setDownline] = useState([]);
    const [paymentModes, setpaymentModes] = useState([]);
    const [IsFetchAllList, setisFetchAllList] = useState(false);
    const [parentBankDetails, setParentBankDetails] = useState([]);
    const [shouldDisplayBankName, setShouldDisplayBankName] = useState(false);
    const [currentUserID] = useState(localStorage.getItem('UserID'));
    const [InWords, setInWords] = useState('');
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }

    const [PaymodeOnOff, setPaymodeOnOff] = useState(false);
    const fetchPaymodeOnOff = async () => {
        let isOn = await SHOW_PAYMODE();
        if (formRef.current) {
            formRef.current.values.PayMode = 'Cash';
        }
        if (isOn === 'YES') {
            setPaymodeOnOff(true);
            if (formRef.current) {
                formRef.current.values.PayMode = '0';
            }
            return;
        }
    };

    const selectPaymentModesWallets = async (UserID) => {
        var request = {
            UserID: UserID
        };
        var json = JSON.stringify(request);

        const response = await SELECT_PAYMENT_MODE_BYID(json);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);
        setpaymentModes(data);
    };

    const [formObj, setFormObj] = useState({
        BankID: 0,
        Mode: 0,
        Amount: 0,
        Remark: ''
    });

    const validationSchema = Yup.object({
        Remark: Yup.string().required(PLEASE_SELECT_VALID + 'Remark'),

        Amount: Yup.number()
            .moreThan(0, PLEASE_PROVIDE_VALID + 'amount')
            .required(PLEASE_PROVIDE_VALID + 'amount')
    });
    useEffect(() => {
        setLoadingOpen(true);
        fetchConsumerNumberFontSize();
        fetchPaymodeOnOff();
        selectPaymentModesWallets(1);
        setLoadingOpen(false);
    }, []);

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(false);
        let requestObj = {
            BankID: values.BankID,
            PaymentModeMasterID: values.PayMode,
            Amount: values.Amount,
            Type: values.Type,
            Remark: values.Remark
        };
        setLoadingOpen(true);
        const response = await INSERT(JSON.stringify(requestObj));
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            return;
        }
        reset();
    };
    const SelectParentBanks = async (ParentID) => {
        if (ParentID <= 0) return;
        let request = {
            ParentID: ParentID
        };
        let json = JSON.stringify(request);

        const { isAuthorized, status, data } = await SELECT_BY_PARENT_ID(json);

        if (!isAuthorized) LOGOUT();

        if (!status) {
            setResponseMessage(data);
            setIsError(true);
            return;
        }

        let d = JSON.parse(data);

        setParentBankDetails(d);
        if (d.length > 0) setShouldDisplayBankName(true);
    };

    const reset = () => {
        setInWords('');
        setShouldDisplayBankName(false);

        setFormObj({
            Type: 0,
            Amount: '',

            PayMode: 0,
            BankName: 0,
            Remark: ''
        });
    };

    const OnAmountChangeCore = (value, setFieldValue) => {
        if (value === undefined || value === null || value <= 0) {
            setFieldValue('InWords');
            setInWords('');
            return;
        }

        let wwords = NumberToWord(value);
        setInWords(wwords);
        setFieldValue('InWords', wwords);
    };

    const handlePayModeChange = (name, value, setFieldValue) => {
        setFieldValue(name, value);

        if (value === 3) {
            SelectParentBanks(currentUserID);
            return;
        }

        setShouldDisplayBankName(false);
    };

    const PayModeList = paymentModes.map(({ PaymentModeMasterID, Type }) => (
        <MenuItem key={PaymentModeMasterID} value={PaymentModeMasterID}>
            {Type}
        </MenuItem>
    ));

    const ParentBankDetailList = parentBankDetails.map(
        ({ BankName, UserBankDetailsID }) => (
            <MenuItem key={UserBankDetailsID} value={UserBankDetailsID}>
                {BankName}
            </MenuItem>
        )
    );

    const BankNamesDropDown = shouldDisplayBankName ? (
        <MaterialSelect label="Bank" name="BankID" title="Bank">
            <MenuItem key="0" value="0">
                Select BankName
            </MenuItem>

            {ParentBankDetailList}
        </MaterialSelect>
    ) : null;

    const TransferForm = ({ values, errors, setFieldValue }) => {
        return (
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <CustomContainer
                            isLoading={loadingOpen}
                            isError={isError}
                            alertMessage={responseMessage}
                            severity={severity}
                            onCloseCallback={(alertState) => {
                                setIsError(alertState);
                            }}
                        >
                            <Form>
                                <Grid
                                    spacing={5}
                                    container
                                    style={{
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={4}
                                        sm={4}
                                        md={4}
                                        lg={4}
                                        xl={4}
                                    >
                                        <Grid
                                            container
                                            spacing={2}
                                            sx={{
                                                justifyContent: 'center'
                                            }}
                                        >
                                            {PaymodeOnOff && (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                >
                                                    <MaterialSelect
                                                        label="Pay Mode"
                                                        name="PayMode"
                                                        title="Select Mode"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            handlePayModeChange(
                                                                name,
                                                                value,
                                                                setFieldValue
                                                            );
                                                        }}
                                                    >
                                                        <MenuItem
                                                            key="0"
                                                            value="0"
                                                        >
                                                            Select Mode
                                                        </MenuItem>
                                                        {PayModeList}
                                                    </MaterialSelect>
                                                </Grid>
                                            )}
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                            >
                                                {BankNamesDropDown}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                            >
                                                <MaterialCurrency
                                                    font_size={
                                                        consumerNumberFontSize
                                                    }
                                                    name="Amount"
                                                    label="Amount"
                                                    placeholder="Amount"
                                                    autoComplete="new-password"
                                                    max={9999999999}
                                                    onCustomCallback={(
                                                        value
                                                    ) => {
                                                        OnAmountChangeCore(
                                                            value,
                                                            setFieldValue
                                                        );
                                                    }}
                                                />
                                                <InputLabel
                                                    color="green"
                                                    value={InWords}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                            >
                                                <MaterialSelect
                                                    label="Type"
                                                    name="Type"
                                                    title="Bank"
                                                >
                                                    <MenuItem
                                                        key="Credit"
                                                        value="Credit"
                                                    >
                                                        Credit
                                                    </MenuItem>
                                                    <MenuItem
                                                        key="Debit"
                                                        value="Debit"
                                                    >
                                                        Debit
                                                    </MenuItem>
                                                </MaterialSelect>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                            >
                                                <MaterialTextField
                                                    label="Remark"
                                                    name="Remark"
                                                    type="text"
                                                    length={150}
                                                    title="Remark"
                                                />
                                            </Grid>
                                        </Grid>

                                        <Divider
                                            variant="middle"
                                            className="rechdevider"
                                        />

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            spacing={2}
                                            container
                                        >
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    sm={12}
                                                    md={12}
                                                    lg={6}
                                                    xl={6}
                                                >
                                                    <PrimaryButton
                                                        type="submit"
                                                        title="Submit"
                                                        sx={{
                                                            marginTop: 3,
                                                            height: '50px',
                                                            textTransform:
                                                                'none',
                                                            paddingX: '50px',
                                                            borderRadius: '4px'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    sm={12}
                                                    md={12}
                                                    lg={6}
                                                    xl={6}
                                                >
                                                    <SecondaryButton
                                                        type="reset"
                                                        variant="contained"
                                                        color="secondary"
                                                        title="Reset"
                                                        sx={{
                                                            marginTop: 3,
                                                            height: '50px',
                                                            textTransform:
                                                                'none',
                                                            paddingX: '50px',
                                                            borderRadius: '4px'
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Form>
                        </CustomContainer>
                    </Grid>
                </Grid>
            </>
        );
    };

    return (
        <Formik
            innerRef={formRef}
            enableReinitialize={true}
            initialValues={formObj}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            resetForm={formObj}
        >
            {TransferForm}
        </Formik>
    );
};
export default VoucherModeBalanceAdd;
